__turbopack_context__.v({
  "container": "WnjxAa_container",
  "image": "WnjxAa_image",
});
